import { Icons, Link, SvgSpriteConsumer } from '@pluxee-design-system/core';
import { ComponentProps } from 'components/VirtualizedTable/types';
import { Employee } from 'generated/models';
import NextLink from 'next/link';
import { useCallback } from 'react';
import gtm from 'trackers/gtm';

const DetailsCell = ({
  index,
  row: { firstName, middleName, lastName, uid },
}: ComponentProps<Employee>) => {
  const fullName = [firstName, middleName, lastName].filter((x) => x).join(' ');

  const trackClick = useCallback(() => {
    gtm.trackClickEmployeesDetails(uid, fullName, index);
  }, [fullName, index, uid]);

  return (
    <Link
      as={NextLink}
      href={`/employees/${uid}`}
      onClick={trackClick}
      prefetch={false}
      variant="primary"
    >
      <SvgSpriteConsumer size={24} svgId={Icons.THREE_DOTS_VERTICAL24} />
    </Link>
  );
};

export default DetailsCell;
